import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stunning%20Japanese%20anime%20style%20landscape%20of%20a%20coastal%20island%20town%20with%20a%20giant%20blooming%20cherry%20blossom%20tree%20at%20the%20center%20glowing%20with%20soft%20magical%20light%20warm%20golden%20sunset%20sky%20pink%20petals%20floating%20in%20the%20air%20peaceful%20dreamy%20atmosphere%20cinematic%20composition%20high%20detail%20digital%20illustration&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="初音岛"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="mb-6">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-sm border border-background-50/30">
            <i className="ri-flower-line"></i>
            探索初音岛的一切
          </span>
        </div>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
          欢迎来到
          <span className="block mt-2 text-primary-300">初音岛的世界</span>
        </h1>
        <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-8 leading-relaxed">
          初音岛是广受欢迎的视觉小说系列作品。无论您是新玩家还是资深粉丝，都能在这里找到关于初音岛的剧情、角色、攻略与周边的最权威内容指南。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/plot-analysis"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            开始探索 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/30 transition-all whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}